import { createFileRoute } from "@tanstack/react-router";
import { RespondScreen } from "@modules/applications/views";

/**
 * `/applicant/applications/$applicationId/respond` — US-E4-04 "Supply exactly what was asked
 * for". Inherits the applicant group guard from the `/applicant` layout route, same as the
 * dossier route.
 *
 * ⚠ `$applicationId` is escaped (trailing underscore) because
 * `applicant.applications.$applicationId.tsx` is a LEAF route with no `<Outlet/>` — without the
 * escape this route would nest under it and never mount, the exact gotcha documented in
 * `rules/rounds.md` and hit again for the operations dossier detail route.
 */
export const Route = createFileRoute(
  "/applicant/applications/$applicationId_/respond"
)({
  component: RespondRoute,
});

function RespondRoute() {
  const { applicationId } = Route.useParams();
  return <RespondScreen applicationId={applicationId} />;
}
